module.exports = new __parcel__URL__("battlepass_season_image.1a0aef85.png").toString();